import { useContext, useState } from 'react'

import { useSelector } from 'react-redux'
import { Button, Form, Steps } from 'antd'
import { isFunction } from 'lodash'
import FormItem from 'antd/es/form/FormItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowTurnDownLeft, faIdCard, faUserPen } from '@fortawesome/pro-duotone-svg-icons'

import { selectTranslate } from '../../reducers/LocaleReducer/LocalReducer'
import { DEFAULT_DATA, InternshipRequestPortalFormContext, Modes } from '../../Providers/Forms/InternshipRequestPortal/InternshipRequestPortalFormProvider'

const RETURN_BUTTON_HEIGHT = '40px'

const InterneoAccountForm = ({ visible = false, onAccountTypeSelect, onHasAccount }) => {
  const { setFormHandler } = useContext(InternshipRequestPortalFormContext)

  const t = useSelector(selectTranslate)

  const [step, setStep] = useState(0)

  const handleAccountChange = mode => {
    if (mode !== null) {
      const initData = DEFAULT_DATA[mode]

      setFormHandler({ data: initData, mode, callback: null })

      if (isFunction(onAccountTypeSelect)) {
        onAccountTypeSelect()
      }
    } else {
      setStep(0)
    }
  }

  const steps = [
    {
      key: 0,
      title: t('internship_account_form.authenticate'),
      icon: faIdCard
    },
    {
      key: 1,
      title: t('internship_account_form.create_account'),
      icon: faUserPen
    }
  ]

  if (!visible) {
    return null
  }

  return (
    <Form className='login-form h-100-i'>
      <div className='flex-col h-100'>

        <Steps current={step} type='navigation'>
          {steps.map(item => (
            <Steps.Step key={item.key} title={item.title} icon={<FontAwesomeIcon icon={item.icon} />} style={{ cursor: 'pointer' }} onClick={() => setStep(item.key)} />
          ))}
        </Steps>

        {step === 0 && (
          <FormItem>
            <label>{t('interneo_account_form.questions.has_account')}</label>
            <div className='flex-row jc-around gap-12 mt-4'>
              <Button className='flex-fill logo-colored-button blue-ghost blue-hover' type='primary' onClick={onHasAccount}>{t('common.yes_account')}</Button>
              <Button className='flex-fill logo-colored-button orange-ghost orange-hover' hover='' type='default' onClick={() => setStep(s => ++s)}>{t('common.no_account')}</Button>
            </div>

            <div style={{ height: RETURN_BUTTON_HEIGHT }} />
          </FormItem>
        )}
        {step === 1 && (
          <FormItem>
            <label>{t('interneo_account_form.questions.student_or_school')}</label>
            <div className='flex-row jc-around gap-12 mt-4'>
              <Button className='flex-fill logo-colored-button green-ghost green-hover' type='primary' onClick={() => handleAccountChange(Modes.STUDENT)}>{t('common.student')}</Button>
              <Button className='flex-fill logo-colored-button blue-ghost blue-hover' type='default' onClick={() => handleAccountChange(Modes.SCHOOL)}>{t('common.school')}</Button>
            </div>

            <Button className='mt-4-i logo-colored-button gray-ghost gray-hover' onClick={() => handleAccountChange(null)} style={{ maxHeight: RETURN_BUTTON_HEIGHT }}>
              <span className='ai-ctr'>
                <FontAwesomeIcon icon={faArrowTurnDownLeft} /> {t('common.return')}
              </span>
            </Button>
          </FormItem>
        )}

      </div>
    </Form>
  )
}

export default InterneoAccountForm
